import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useUmbrellaAccount } from '@/modules/shared/hooks/useUmbrellaAccount'

/**
 * Replaces per-company billing screens for a company under a service account: its
 * invoices and subscription live on the account, so there is nothing of its own to show.
 */
export const UmbrellaBillingNotice: React.FC<{ companyId: string }> = ({
  companyId,
}) => {
  const { t } = useLocalize()
  const navigate = useNavigate()
  const { umbrella, canOpenUmbrella, isOwner } = useUmbrellaAccount(companyId)
  if (!umbrella) return null

  const name = umbrella.invoiceCompanyName || umbrella.companyName || ''
  return (
    <div className="tw-m-6 tw-max-w-2xl tw-rounded tw-border tw-border-gray-200 tw-p-4 tw-text-sm tw-text-gray-700">
      <p className="tw-mb-3 tw-mt-0">
        {t('serviceAccount.billed-under-notice', { name })}
      </p>
      {canOpenUmbrella ? (
        <button
          // An owner cannot open the account as a company (it is not in their picker), so they
          // go to the account panel; a global admin opens the account's own subscription.
          onClick={() =>
            navigate(
              isOwner
                ? `/et/company/${companyId}/serviceAccount`
                : `/et/company/${umbrella.id}/my-subscription`,
            )
          }
          className="tw-cursor-pointer tw-rounded tw-bg-blue-600 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white hover:tw-bg-blue-700"
        >
          {t('serviceAccount.billed-under-open')}
        </button>
      ) : (
        <p className="tw-m-0 tw-text-xs tw-text-gray-500">
          {t('serviceAccount.billed-under-member')}
        </p>
      )}
    </div>
  )
}
